var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [_vm.images.length == 0 && _vm.isPdp ? "d-none" : ""],
      attrs: { id: "pc-inspiration-gallery" }
    },
    [
      !_vm.isPdp
        ? _c("div", { staticClass: "pc-inspiration-page-header" }, [
            _c("h2", [
              _vm._v(
                _vm._s(
                  _vm.$resourceString["inspiration.welcome.to.inspiration"]
                )
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          !_vm.isPdp
            ? _c("pc-inspiration-section-page-display-control")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isPdp
        ? _c("pc-inspiration-section-page-gallery")
        : _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row mt-4" }, [
              _c("div", { staticClass: "col-md-12 mb-3" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "wf-side-collapse-button wf-side-collapse-button-open btn d-lg-block d-none pl-0",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.triggerDesktopFilter()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "pr-3" }, [
                      _vm._v(
                        _vm._s(
                          !_vm.isDesktopFilterShow
                            ? _vm.$resourceString[
                                "product.Search.Filters.Button.Show"
                              ]
                            : _vm.$resourceString[
                                "product.Search.Filters.Button.Hide"
                              ]
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "png-icon png-icon-icons-glyph--k-sort-filter m-0"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "wf-side-collapse-button wf-side-collapse-button-open btn d-lg-none pl-0",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.triggerMobileFilter()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "pr-3" }, [
                      _vm._v(
                        _vm._s(
                          !_vm.isMobileFilterShow
                            ? _vm.$resourceString[
                                "product.Search.Filters.Button.Show"
                              ]
                            : _vm.$resourceString[
                                "product.Search.Filters.Button.Hide"
                              ]
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "png-icon png-icon-icons-glyph--k-sort-filter m-0"
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.isDesktopFilterShow
                ? _c(
                    "div",
                    { staticClass: "col-12 col-md-3 d-lg-block d-none" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [_c("pc-inspiration-gallery-current-filters")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [_c("pc-inspiration-gallery-side-filters")],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  class:
                    "col-12 col-md-12 " +
                    (_vm.isDesktopFilterShow ? "col-lg-9" : "")
                },
                [_c("pc-inspiration-section-page-gallery")],
                1
              )
            ])
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "wf-product-category-sidebar-mobile" }, [
        _c(
          "div",
          {
            class:
              "wf-side-collapse " +
              (_vm.isMobileFilterShow ? "wf-side-collapse-active" : ""),
            attrs: { id: "filters-side-collapse" }
          },
          [
            _c(
              "div",
              { staticClass: "wf-side-collapse-header justify-content-end" },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "wf-side-collapse-button wf-side-collapse-button-close btn",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.triggerMobileFilter()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$resourceString["product.search.close.button"]
                        ) +
                        "\n          "
                    ),
                    _c("span", {
                      staticClass: "png-icon png-icon-icons-glyph--g-close",
                      attrs: { "aria-label": "close button" }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wf-side-collapse-body" }, [
              _c(
                "div",
                { staticClass: "wf-side-collapse-section border-bottom-line" },
                [_c("pc-inspiration-gallery-current-filters")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "wf-side-collapse-section" },
                [_c("pc-inspiration-gallery-side-filters")],
                1
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.pageNumber > 1 && !_vm.isPdp ? _c("wf-back-to-top-button") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }